/**
 * MDJ Curate — cart integration
 * Maison de Jarin
 *
 * The theme's own product-form add-to-cart (assets/theme-global.js) posts
 * to window.MinimogSettings.routes.cart_add_url — NOT a hardcoded
 * '/cart/add.js' string — as FormData, and on failure emits
 * MinimogTheme.pubSubEvents.cartError. This uses the SAME route object
 * (falling back to '/cart/add.js' only if MinimogSettings hasn't loaded
 * yet) and emits the same cartError event, so any sitewide error-handling
 * that listens for it still fires. The body is JSON rather than FormData
 * — Shopify's cart/add.js endpoint accepts both; the theme uses FormData
 * because its generic product form can contain file inputs, which this
 * configurator never does, so JSON is simpler and equally valid here,
 * not a competing convention.
 *
 * Quantity CHANGES elsewhere in the theme go through
 * routes.cart_change_url with a sections:[] payload (assets/cart.js) —
 * this is the initial ADD only, so that mechanism doesn't apply here.
 */

(function () {
  'use strict';

  function cartAddUrl() {
    return (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) || '/cart/add.js';
  }

  function fetchCartAdd(payload) {
    var body = {
      items: [
        {
          id: payload.variantId,
          quantity: 1,
          properties: payload.properties
        }
      ]
    };

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'Could not add this blend to your cart.');
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function friendlyMessage(err) {
    if (!err) return 'Something went wrong. Please try again.';
    if (err.status === 422) {
      // Sold-out variant or validation error — Shopify's own description
      // is usually customer-readable ("Sold out", quantity errors, etc.)
      return (err.data && err.data.description) || 'That size is currently sold out.';
    }
    if (err.message === 'Failed to fetch' || err.name === 'TypeError') {
      return 'Network error — please check your connection and try again.';
    }
    return err.message || 'Something went wrong. Please try again.';
  }

  function add(payload, callbacks) {
    callbacks = callbacks || {};
    if (!payload.variantId) {
      if (callbacks.onError) callbacks.onError('This size is not available right now.');
      return;
    }

    fetchCartAdd(payload)
      .then(function () {
        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'mdj-curate' });
        }
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          // Refresh drawer contents before opening — mirrors
          // MCartDrawer.onCartDrawerUpdate()'s own section refetch so the
          // new line item actually appears, since add.js itself doesn't
          // return rendered section HTML the way cart/change.js does.
          fetch(window.location.pathname + '?section_id=cart-drawer')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var itemsSrc = doc.querySelector('[data-minimog-cart-items]');
              var itemsDest = document.querySelector('[data-minimog-cart-items]');
              if (itemsSrc && itemsDest) itemsDest.innerHTML = itemsSrc.innerHTML;
              drawer.classList.remove('m-cart--empty');
              drawer.open();
            })
            .catch(function () {
              drawer.open();
            });
        }
        if (callbacks.onSuccess) callbacks.onSuccess();
      })
      .catch(function (err) {
        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartError, {
            source: 'mdj-curate',
            productVariantId: payload.variantId,
            errors: err.data && err.data.description,
            message: err.message
          });
        }
        if (callbacks.onError) callbacks.onError(friendlyMessage(err));
      });
  }

  window.MDJCurateCart = { add: add };
})();
